import PropTypes from 'prop-types';
import React, { Component } from 'react';

require("./HorseRacingRacecardPreRaceNotification.scss")

class HorseRacingRacecardPreRaceNotification extends Component {

    static propTypes = {
        children: PropTypes.node.isRequired
    }

    render() {
        return (
            <section className="hr-racecard-notification-container">
                <span className="hr-racecard-notification-message">
                    <b className="hr-racecard-notification-message-highlight">NEW!</b> 
                    {this.props.children}
                </span>
            </section>
        )
    }
}

export default HorseRacingRacecardPreRaceNotification



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardPreRaceNotification.js